class enumTamanios {
//tamaños_animal: ['MP', 'P', 'M', 'G', 'MG'],
    constructor(){
        this.tamaniosEnum = {
            MP : "Muy pequeño",
            P : "Pequeño",
            M : "Mediano",
            G : "Grande",
            MG : "Muy grande"
        };

        this.convertir = this.convertir.bind(this);
    }

    convertir(tamanio){
        return this.tamaniosEnum[tamanio]
    }

    revertir(tamanio) {
        return Object.keys(this.tamaniosEnum).find(key => this.tamaniosEnum[key] === tamanio);
    }
}

export default enumTamanios
